export default {
  translation: {
    // Common
    "app.name": "Give Protocol",
    "app.tagline": "透明、无国界的慷慨基础设施。",
    "common.skipToMainContent": "跳到主要内容",
    "common.cancel": "取消",
    "common.edit": "编辑",
    "common.delete": "删除",
    "common.creating": "创建中...",
    "common.unknown": "未知",
    "common.notAvailable": "不适用",

    // Navigation
    "nav.browse": "浏览慈善机构",
    "nav.opportunities": "志愿服务机会",
    "nav.contributions": "贡献追踪",
    "nav.governance": "治理",
    "nav.dashboard": "控制面板",
    "nav.about": "关于",
    "nav.docs": "文档",
    "nav.legal": "法律",
    "nav.launchApp": "启动应用",

    // FAQ page (GIV-988)
    "faq.title": "常见问题",
    "faq.subtitle": "关于捐赠、志愿服务和区块链透明度，您需要了解的一切。",

    // Settings
    "settings.title": "设置",
    "settings.language": "语言",
    "settings.currency": "货币",

    // Auth
    "auth.login": "登录",
    "auth.register": "创建账户",
    "auth.logout": "退出登录",
    "auth.forgotPassword": "忘记密码？",

    // Dashboard
    "dashboard.title": "控制面板",
    "dashboard.subtitle": "追踪您的捐赠和志愿贡献",
    "dashboard.totalDonations": "捐赠总额",
    "dashboard.volunteerHours": "志愿时长",
    "dashboard.skillsEndorsed": "获认可技能",
    "dashboard.contributions": "贡献",
    "dashboard.yourTotalDonated": "您的捐赠总额",
    "dashboard.yourVolunteerHours": "您的志愿时长",
    "dashboard.yourSkillsEndorsed": "您获认可的技能",
    "dashboard.impactGrowth": "影响力增长",
    "dashboard.charitiesSupported": "支持的慈善机构",

    // Charity
    "charity.dashboard": "慈善机构面板",
    "charity.subtitle": "管理您的捐赠和志愿者项目",
    "charity.activeVolunteers": "活跃志愿者",
    "charity.transactions": "交易记录",
    "charity.volunteers": "志愿时长",
    "charity.applications": "申请",
    "charity.totalReceived": "累计收到",
    "charity.equityPoolValue": "公平池价值",
    "charity.availableBalance": "可用余额",

    // Contributions
    "contributions.date": "日期",
    "contributions.type": "类型",
    "contributions.organization": "组织",
    "contributions.details": "详情",
    "contributions.status": "状态",
    "contributions.verification": "验证",
    "contributions.export": "导出 CSV",

    // Volunteer
    "volunteer.opportunities": "志愿服务机会",
    "volunteer.searchOpportunities": "搜索机会...",
    "volunteer.selectSkill": "选择技能",
    "volunteer.selectType": "选择类型",
    "volunteer.selectLanguage": "选择语言",
    "volunteer.allSkills": "所有技能",
    "volunteer.allTypes": "所有类型",
    "volunteer.allLanguages": "所有语言",
    "volunteer.applyNow": "立即申请",
    "volunteer.noOpportunitiesFound": "未找到符合条件的机会。",
    "volunteer.verify": "验证时长",
    "volunteer.verifying": "验证中...",
    "volunteer.reject": "拒绝",
    "volunteer.accept": "接受",
    "volunteer.processing": "处理中...",
    "volunteer.hours": "小时于",
    "volunteer.description": "描述",
    "volunteer.appliedFor": "已申请",
    "volunteer.verificationComplete": "验证完成",
    "volunteer.hoursVerified": "志愿时长已验证并记录在区块链上。",
    "volunteer.verificationHash": "验证哈希",
    "volunteer.applicationAccepted": "申请已接受",
    "volunteer.applicationRecorded": "志愿者申请已被接受并记录在区块链上。",
    "volunteer.acceptanceHash": "接受哈希",
    "volunteer.pendingHours": "待验证志愿时长",
    "volunteer.noPendingHours": "没有待验证的志愿时长。",
    "volunteer.pendingApplications": "待审核申请",
    "volunteer.noPendingApplications": "没有待审核的申请。",
    "volunteer.createOpportunity": "创建志愿服务机会",
    "volunteer.createNew": "创建新机会",
    "volunteer.noOpportunitiesYet":
      "尚未创建任何机会。点击\u201c创建新机会\u201d开始。",
    "volunteer.opportunityTitle": "机会标题",
    "volunteer.skills": "技能（以逗号分隔）",
    "volunteer.commitment": "承诺",
    "volunteer.location": "地点",
    "volunteer.type": "类型",
    "volunteer.workLanguage": "工作语言",
    "volunteer.status": "状态",

    // Volunteer commitment types
    "volunteer.commitment.oneTime": "一次性",
    "volunteer.commitment.shortTerm": "短期",
    "volunteer.commitment.longTerm": "长期",

    // Volunteer types
    "volunteer.type.remote": "远程",
    "volunteer.type.onsite": "现场",
    "volunteer.type.hybrid": "混合",
    "volunteer.type.onSite": "现场",

    // Volunteer - Opportunities page
    "volunteer.workTypeFilter": "工作类型筛选",
    "volunteer.searchLocation": "城市或地区...",
    "volunteer.searchLocationAria": "搜索地点",
    "volunteer.filter.skill": "技能：{{value}}",
    "volunteer.filter.type": "类型：{{value}}",
    "volunteer.filter.language": "语言：{{value}}",
    "volunteer.filter.location": "地点：{{value}}",
    "volunteer.loadingOpportunities": "正在加载机会...",
    "volunteer.loadOpportunitiesError": "无法加载志愿者机会，请稍后再试。",
    "volunteer.viewDetails": "查看详情",
    "volunteer.backToOpportunities": "返回机会列表",
    "volunteer.detail.about": "关于此机会",
    "volunteer.detail.skills": "所需技能",
    "volunteer.detail.commitment": "时间投入",
    "volunteer.detail.location": "地点",
    "volunteer.detail.language": "语言",
    "volunteer.detail.hostedBy": "主办方",
    "volunteer.detail.ongoing": "长期进行",
    "volunteer.detail.applicationsClosed": "申请已截止",
    "volunteer.detail.notFoundTitle": "未找到该机会",
    "volunteer.detail.notFoundMessage": "该机会可能已招满或已被移除。",
    "volunteer.field.requirements": "要求",
    "volunteer.field.benefits": "福利",
    "volunteer.field.schedule": "时间安排",
    "volunteer.field.schedulePlaceholder": "例如：周二 18:00-20:00，周末灵活",
    "volunteer.field.startDate": "开始日期",
    "volunteer.field.endDate": "结束日期",
    "volunteer.field.endDateHelp": "如长期进行请留空",
    "volunteer.field.applicationDeadline": "申请截止日期",
    "volunteer.field.volunteersNeeded": "所需志愿者人数",
    "volunteer.field.minimumAge": "最低年龄",
    "volunteer.field.backgroundCheckRequired": "需要背景调查",
    "volunteer.field.trainingProvided": "提供培训",
    "volunteer.field.onePerLine": "每行一项",
    "volunteer.validation.volunteersNeeded": "请输入大于等于 1 的数字",
    "volunteer.validation.minimumAge": "请输入 0 到 120 之间的年龄",
    "volunteer.validation.endDate": "结束日期不得早于开始日期",
    "volunteer.signInToApply": "请登录后申请志愿服务机会",
    "volunteer.applicationSuccess": "申请提交成功！",
    "volunteer.removeFilter": "移除 {{filter}} 筛选",

    // Volunteer - OpportunityForm
    "volunteer.validation.titleRequired": "标题为必填项",
    "volunteer.validation.descriptionRequired": "描述为必填项",
    "volunteer.validation.skillsRequired": "至少需要一项技能",
    "volunteer.validation.locationRequired": "地点为必填项",
    "volunteer.profileNotFound": "未找到用户资料",
    "volunteer.correctErrors": "请更正验证错误",
    "volunteer.createFailed": "创建机会失败",
    "volunteer.descriptionPlaceholder": "详细描述此志愿服务机会...",
    "volunteer.skillsPlaceholder": "例如：网页开发、项目管理、翻译",
    "volunteer.locationPlaceholder": "例如：远程、纽约、柏林",
    "volunteer.headerImage": "封面图片",
    "volunteer.headerImageHelp": "上传一张图片显示在您的机会列表顶部",
    "volunteer.limitReached": "机会数量已达上限",
    "volunteer.limitReachedMessage":
      "您已达到最多 {{max}} 个活跃志愿机会的上限。请关闭或完成一个现有机会后再创建新机会。",
    "volunteer.opportunityCount": "您有 {{count}} / {{max}} 个活跃机会。",

    // Volunteer - HoursVerificationTab
    "volunteer.hoursVerification": "时长验证",
    "volunteer.hoursVerificationDescription": "审核和验证志愿时长提交",
    "volunteer.formalHours": "已记录时长",
    "volunteer.selfReported": "自行报告",
    "volunteer.loggedHours": "已记录志愿时长",
    "volunteer.loggedHoursDescription": "志愿者通过您的机会记录的时长",
    "volunteer.allCaughtUp": "全部处理完毕！",
    "volunteer.noPendingLoggedHours": "没有待验证的已记录时长。",
    "volunteer.selfReportedHours": "自行报告时长",

    // Volunteer - OpportunitiesTab
    "volunteer.noOpportunitiesTitle": "暂无机会",
    "volunteer.activeCount": "{{count}} / {{max}} 个活跃机会",
    "volunteer.moreSkills": "+{{count}} 更多",

    // Volunteer - ApplicationsTab
    "volunteer.noApplications": "没有待审核的申请",
    "volunteer.unknownOpportunity": "未知机会",

    // Volunteer - VerificationLookup
    "volunteer.verifyContribution": "验证志愿贡献",
    "volunteer.hashPlaceholder": "输入验证哈希",
    "volunteer.searching": "搜索中...",
    "volunteer.verifyHash": "验证哈希",
    "volunteer.verificationNotFound": "未找到验证记录",
    "volunteer.verificationNotFoundMessage":
      "您提供的哈希未在我们的记录中找到。请检查哈希后重试。",
    "volunteer.unknownOrganization": "未知组织",

    // Volunteer - VolunteerVerificationCard
    "volunteer.contributionVerification": "志愿贡献验证",
    "volunteer.volunteerLabel": "志愿者",
    "volunteer.opportunityLabel": "机会",
    "volunteer.organizationLabel": "组织",
    "volunteer.acceptedOn": "接受日期",
    "volunteer.verifiedOn": "验证日期",
    "volunteer.verificationHashes": "验证哈希",
    "volunteer.blockchainReference": "区块链引用",

    // Volunteer - VerifyContribution page
    "volunteer.verifyingContribution": "正在验证贡献\u2026",
    "volunteer.noHashProvided": "未提供验证哈希。",
    "volunteer.verificationSuccessful": "验证成功",
    "volunteer.contributionVerifiedBlockchain":
      "此志愿贡献已验证并记录在区块链上。",
    "volunteer.verificationFailed": "验证失败",
    "volunteer.hashNotFound": "验证哈希 {{hash}} 未找到或无效。",

    // Volunteer - SelfReportedHoursDashboard
    "volunteer.volunteerHoursTitle": "志愿时长",
    "volunteer.aboutSelfReported": "关于自行报告时长",
    "volunteer.selfReportedInfo":
      "只有经认证组织验证的时长才计入全球影响力排名。未在平台注册的组织的时长可以记录，但在获得验证前将标记为\u201c未验证\u201d。",
    "volunteer.logHoursButton": "记录时长",
    "volunteer.logVolunteerHours": "记录志愿时长",
    "volunteer.editRecord": "编辑记录",
    "volunteer.recordDetails": "记录详情",
    "volunteer.backToList": "返回列表",
    "volunteer.deleteRecord": "删除记录？",
    "volunteer.deleteConfirmation":
      "确定要删除此志愿时长记录吗？此操作无法撤消。",

    // Volunteer - SelfReportedHoursForm
    "volunteer.activityType": "活动类型",
    "volunteer.organization": "组织",
    "volunteer.searchRegistry": "搜索注册信息",
    "volunteer.searchRegistryPlaceholder": "按名称或税务编号搜索慈善机构登记…",
    "volunteer.registryTaxId": "税务编号 {{value}}",
    "volunteer.notListed": "未列出",
    "volunteer.organizationName": "组织名称",
    "volunteer.enterOrgName": "输入组织名称",
    "volunteer.contactEmail": "联系邮箱",
    "volunteer.contactEmailOptional": "（选填）",
    "volunteer.onboardHelp": "我们可能会联系以帮助该组织入驻",
    "volunteer.submittedForValidation": "此记录将提交验证",
    "volunteer.submittedForValidationTo": "此记录将提交给 {{org}} 进行验证",
    "volunteer.validationExpired": "此日期的验证期已过",
    "volunteer.savedAsUnvalidated": "此记录将保存为未验证",
    "volunteer.describeActivities": "描述您执行的活动...",
    "volunteer.moreCharsNeeded": "还需 {{count}} 个字符",
    "volunteer.updating": "更新中...",
    "volunteer.logging": "记录中...",
    "volunteer.updateHours": "更新时长",

    // Volunteer - SelfReportedHoursList
    "volunteer.statusFilter": "状态",
    "volunteer.activityTypeFilter": "活动类型",
    "volunteer.filterFrom": "从",
    "volunteer.filterTo": "到",
    "volunteer.clearFilters": "清除筛选",
    "volunteer.allStatuses": "全部",
    "volunteer.allActivityTypes": "所有类型",
    "volunteer.noMatchingRecords": "没有匹配的记录",
    "volunteer.noHoursLogged": "尚未记录任何志愿时长",
    "volunteer.adjustFilters": "尝试调整筛选条件来查找记录。",
    "volunteer.startLogging": "开始记录您的第一次志愿时长。",

    // Volunteer - SelfReportedHoursStats
    "volunteer.validatedHours": "已验证时长",
    "volunteer.pendingValidation": "待验证",
    "volunteer.unvalidatedHours": "未验证时长",
    "volunteer.rejectedLabel": "已拒绝",
    "volunteer.hoursUnit": "小时",
    "volunteer.recordSingular": "条记录",
    "volunteer.recordPlural": "条记录",

    // Volunteer - VolunteerApplicationForm
    "volunteer.applicationTitle": "志愿服务机会申请",
    "volunteer.applicationSubtitle": "通过经验证的贡献帮助创造可持续的影响",
    "volunteer.progress.info": "信息",
    "volunteer.progress.skills": "技能",
    "volunteer.progress.consent": "同意",
    "volunteer.fieldValid": "看起来不错",
    "volunteer.draftSaved": "草稿已保存",
    "volunteer.personalInfo": "个人信息",
    "volunteer.firstName": "名",
    "volunteer.lastName": "姓",
    "volunteer.emailAddress": "电子邮箱",
    "volunteer.phoneNumber": "电话号码",
    "volunteer.locationCity": "所在城市",
    "volunteer.locationCityPlaceholder": "例如：上海",
    "volunteer.timeZone": "时区",
    "volunteer.selectTimeZone": "选择时区",
    "volunteer.ageRange": "年龄范围",
    "volunteer.selectAgeRange": "选择年龄范围",
    "volunteer.skillsAndInterests": "技能与兴趣",
    "volunteer.skillsLabel": "技能和兴趣领域",
    "volunteer.skillPlaceholderFull":
      "输入您的技能（例如：Python编程、公开演讲、项目申请撰写）",
    "volunteer.skillPlaceholderShort": "输入技能并按回车...",
    "volunteer.commitmentLevel": "承诺级别",
    "volunteer.commitmentOneTimeDesc": "单次项目或短期任务",
    "volunteer.commitmentShortTermDesc": "几周到几个月",
    "volunteer.commitmentLongTermDesc": "持续数月或更长时间的承诺",
    "volunteer.experienceLabel": "请介绍您的相关经验",
    "volunteer.experiencePlaceholder":
      "描述您的背景、技能以及您参与 Give Protocol 志愿服务的动机...",
    "volunteer.consentTitle": "同意与协议",
    "volunteer.consentHeader": "志愿者申请同意书",
    "volunteer.submitting": "提交中...",
    "volunteer.submitApplication": "提交志愿者申请",
    "volunteer.disclaimerText":
      "提交此申请即表示您已阅读并理解 Give Protocol 的隐私政策和志愿者指南。您的数据将根据适用的数据保护法规进行处理。",
    "volunteer.validation.firstNameInvalid": "请输入有效的名",
    "volunteer.validation.lastNameInvalid": "请输入有效的姓",
    "volunteer.validation.emailInvalid": "请输入有效的电子邮箱地址",
    "volunteer.validation.phoneInvalid": "请输入有效的电话号码",
    "volunteer.validation.experienceRequired": "请描述您的相关经验",
    "volunteer.validation.addSkill": "请添加至少一项技能",
    "volunteer.validation.ageRangeRequired": "请选择您的年龄范围",
    "volunteer.validation.consentRequired": "您必须同意所有必需的同意项",
    "volunteer.signInToSubmit": "请登录后提交申请",
    "volunteer.submitFailed": "提交申请失败，请重试。",

    // Volunteer - ApplicationForm
    "volunteer.applyForTitle": "申请：{{title}}",
    "volunteer.fullName": "全名 *",
    "volunteer.phoneRequired": "电话号码 *",
    "volunteer.emailRequired": "电子邮箱 *",
    "volunteer.dateOfBirth": "出生日期",
    "volunteer.availabilityTitle": "可用时间",
    "volunteer.preferredDays": "首选日期",
    "volunteer.preferredTimes": "首选时间",
    "volunteer.commitmentLevelLabel": "承诺级别",
    "volunteer.skillsAndExperience": "技能与经验",
    "volunteer.relevantExperience": "相关经验 *",
    "volunteer.certifications": "证书（以逗号分隔）",
    "volunteer.interestsAndPreferences": "兴趣与偏好",
    "volunteer.areasOfInterest": "兴趣领域（以逗号分隔）",
    "volunteer.referencesTitle": "推荐人",
    "volunteer.referenceName": "推荐人 {{index}} 姓名",
    "volunteer.referenceContact": "推荐人 {{index}} 联系方式",
    "volunteer.workSamplesTitle": "作品样本",
    "volunteer.workSamplesLabel": "作品样本链接（以逗号分隔）",
    "volunteer.submitApplicationShort": "提交申请",
    "volunteer.validation.nameInvalid": "请输入有效的姓名（2-100个字符）",
    "volunteer.validation.provideExperience": "请提供您的经验信息",
    "volunteer.validation.selectDay": "请至少选择一天",
    "volunteer.validation.selectTime": "请至少选择一个时间段",

    // Volunteer - ConsentForm
    "volunteer.consentUnderstand": "我理解：",
    "volunteer.processingAckTitle": "处理确认",
    "volunteer.processingAckDesc": "请在继续之前查看并确认以下内容：",
    "volunteer.essentialProcessingTitle": "申请处理（需要确认）：",
    "volunteer.acknowledgmentTitle": "确认",
    "volunteer.ageConfirmationTitle": "年龄确认：",
    "volunteer.privacyNoticeTitle": "隐私声明：",
    "volunteer.doNotAccept": "不接受",
    "volunteer.acceptAndContinue": "接受并继续",
    "volunteer.validation.essentialRequired": "您必须确认申请处理确认才能继续",
    "volunteer.validation.agePrivacyRequired": "您必须确认年龄并已阅读隐私声明",

    // Age affirmation gate (shared across all surfaces — GIV-453)
    "ageGate.positive": "我确认我已年满16周岁。",
    "ageGate.negative":
      "Give Protocol仅供16周岁及以上的用户使用。如果您未满16周岁，我们目前无法处理您的请求。",

    // Languages
    "language.english": "英语",
    "language.spanish": "西班牙语",
    "language.german": "德语",
    "language.french": "法语",
    "language.japanese": "日语",
    "language.chinese_simplified": "简体中文",
    "language.chinese_traditional": "繁体中文",
    "language.thai": "泰语",
    "language.vietnamese": "越南语",
    "language.korean": "韩语",
    "language.arabic": "阿拉伯语",
    "language.hindi": "印地语",
    "language.multiple": "多种语言",

    // Contribution types
    "contribution.type.donation": "捐赠",
    "contribution.type.volunteerapplication": "志愿者申请",
    "contribution.type.volunteerhours": "志愿时长",
    "contribution.type.volunteeracceptance": "志愿者接受",
    "contribution.type.volunteerverification": "志愿者验证",

    // Donor/Volunteer
    "donor.volunteer": "捐赠者/志愿者",
    "donor.anonymous": "匿名",
    "volunteer.unknown": "未知志愿者",

    // Statuses
    "status.completed": "已完成",
    "status.pending": "待处理",
    "status.failed": "失败",

    // Blockchain
    "blockchain.block": "区块",

    // Filter
    "filter.allYears": "所有年份",
    "filter.allTypes": "所有类型",
    "filter.donations": "捐赠",
    "filter.volunteerApplications": "志愿者申请",
    "filter.volunteerHours": "志愿时长",
    "filter.fiatDonations": "法币捐赠",

    // Export
    "export.title": "导出贡献数据",
    "export.filename": "文件名",
    "export.dateRange": "日期范围",
    "export.includePersonal": "包含钱包地址",
    "export.willInclude": "导出将包含：",
    "export.walletAddresses": "钱包地址（发送方和接收方）",
    "export.volunteerDetails": "志愿贡献详情（如适用）",
    "export.verificationHashes": "验证哈希（如适用）",
    "export.cancel": "取消",
    "export.download": "导出 CSV",

    // Skills
    "skills.endorsements": "技能与认可",

    // Home
    "home.subtitle": "将资源连接到最需要的事业",
    "home.startDonating": "开始捐赠",

    // Modal - shared
    "modal.close": "关闭弹窗",
    "modal.closeAriaLabel": "关闭",

    // Modal - wallet connection
    "modal.wallet.title": "连接您的钱包",
    "modal.wallet.description": "连接钱包以解锁 Give Protocol 的全部功能",
    "modal.wallet.benefit1": "在区块链上透明地追踪您的捐赠",
    "modal.wallet.benefit2": "通过贡献获得 GIVE 代币奖励",
    "modal.wallet.benefit3": "参与协议治理决策",
    "modal.wallet.connecting": "连接中...",
    "modal.wallet.clickToConnect": "点击连接",
    "modal.wallet.noExtension": "未检测到钱包扩展。",
    "modal.wallet.installMetaMask": "安装 MetaMask 以开始使用",
    "modal.wallet.skip": "暂时跳过",
    "modal.wallet.footerNote": "您可以随时从导航栏连接钱包",
    "modal.wallet.failedConnect": "连接钱包失败",

    // Modal - wallet link
    "modal.walletLink.title": "关联您的钱包",
    "modal.walletLink.description":
      "将钱包关联到您的账户以进行链上捐赠、获取代币奖励和参与治理",
    "modal.walletLink.benefit1": "直接向链上已验证的慈善机构捐赠加密货币",
    "modal.walletLink.benefit2Pre": "积累",
    "modal.walletLink.benefit2Post": "您的贡献凭证",
    "modal.walletLink.benefit3": "使用邮箱或钱包登录 \u2014 同一账户",
    "modal.walletLink.buttonLinking": "关联中\u2026",
    "modal.walletLink.buttonLink": "关联钱包",
    "modal.walletLink.buttonConnectFirst": "先连接钱包",
    "modal.walletLink.footerNote": "您可以随时从设置中关联钱包",
    "modal.walletLink.failedLink": "关联钱包失败",

    // Modal - chain selection
    "modal.chain.title": "欢迎来到 Give Protocol",
    "modal.chain.subtitle": "选择您偏好的网络以开始使用",
    "modal.chain.footerNote": "您可以随时从菜单切换网络",
    "modal.chain.connecting": "连接中...",
    "modal.chain.continue": "继续",
    "modal.chain.failedSelect": "选择网络失败",

    // Modal - network selection (WalletModal step 1)
    "modal.network.title": "选择网络",
    "modal.network.nextStep": "下一步：连接钱包",
    "modal.network.learnMore": "了解更多关于网络选择的信息",

    // Modal - wallet connect (WalletModal step 2)
    "modal.connect.title": "连接钱包",
    "modal.connect.backAria": "返回网络选择",
    "modal.connect.noWallets": "没有可用于 {{chainType}} 链的钱包。",
    "modal.connect.tryDifferentChain": "尝试选择不同的链类型。",
    "modal.connect.viewOtherWallets": "查看其他支持的钱包",
    "modal.connect.termsAgreement": "连接即表示您同意我们的",
    "modal.connect.termsLink": "服务条款",
    "modal.connect.termsPrivacyConnector": "和",
    "modal.connect.privacyLink": "隐私政策",
    "modal.connect.chainTypeAria": "链类型",
    "modal.connect.failedConnect": "连接失败",

    // Modal - donation
    "modal.donation.successTitle": "谢谢！",
    "modal.donation.donationProcessedOneTime":
      "您向 {{charityName}} 捐赠的 {{amount}} 已处理完成。",
    "modal.donation.donationProcessedRecurring":
      "您向 {{charityName}} 的每月 {{amount}} 捐赠已处理完成。",
    "modal.donation.recurringNote": "将每月扣款直到您取消。",
    "modal.donation.receiptNote": "收据已发送至您的邮箱。",
    "modal.donation.done": "完成",
    "modal.donation.errorTitle": "出了点问题",
    "modal.donation.errorDefault": "发生意外错误，请重试。",
    "modal.donation.tryAgain": "重试",
    "modal.donation.close": "关闭",
    "modal.donation.amountLabel": "捐赠金额",
    "modal.donation.perMonth": "每月",
    "modal.donation.monthly": "按月",
    "modal.donation.oneTime": "一次性",
    "modal.donation.loadingPaymentForm": "正在加载支付表单...",
    "modal.donation.supportMonthly": "每月支持 {{charityName}}",
    "modal.donation.donateToCharity": "捐赠给 {{charityName}}",

    // Modal - scheduled donation
    "modal.scheduledDonation.title": "设置每月向 {{charityName}} 的定期捐赠",

    // Modal - withdrawal
    "modal.withdrawal.title": "申请提现",

    // Modal - validation response
    "modal.validation.rejectTitle": "拒绝验证请求",
    "modal.validation.reviewTitle": "审核验证请求",
    "modal.validation.volunteer": "志愿者",
    "modal.validation.activityDetails": "活动详情",
    "modal.validation.date": "日期",
    "modal.validation.hour": "小时",
    "modal.validation.hours": "小时",
    "modal.validation.activityType": "活动类型",
    "modal.validation.location": "地点",
    "modal.validation.description": "描述",
    "modal.validation.submitted": "提交时间：",
    "modal.validation.daysRemaining": "（剩余 {{count}} 天可验证）",
    "modal.validation.appealNote": "这是先前被拒绝请求的申诉/重新提交",
    "modal.validation.rejectPrompt":
      "请选择拒绝此验证请求的原因。志愿者将收到通知。",
    "modal.validation.reject": "拒绝",
    "modal.validation.approve": "批准",
    "modal.validation.processing": "处理中...",
    "modal.validation.back": "返回",
    "modal.validation.confirmRejection": "确认拒绝",
    "modal.validation.selectReasonError": "请选择拒绝原因",

    // Toast
    "toast.dismiss": "关闭通知",

    // Error boundary
    "error.somethingWrong": "出了点问题",
    "error.unexpectedError": "发生意外错误",
    "error.tryAgain": "重试",
    "error.tooManyAttempts": "尝试次数过多",
    "error.goHome": "返回首页",
    "error.details": "错误详情",

    // Validation - rejection reason select
    "validation.rejection.reasonLabel": "拒绝原因",
    "validation.rejection.reasonPlaceholder": "选择原因...",
    "validation.rejection.notesLabel": "附加说明",
    "validation.rejection.optional": "（选填）",
    "validation.rejection.notesPlaceholder": "提供拒绝的额外说明...",

    // Validation - batch actions
    "validation.batch.deselectAll": "取消全选",
    "validation.batch.selectAll": "全选",
    "validation.batch.selected": "已选 {{selected}} / {{total}}",
    "validation.batch.clear": "清除",
    "validation.batch.reject": "拒绝 ({{count}})",
    "validation.batch.approve": "批准 ({{count}})",

    // Dashboard - admin redirect (GIV-254)
    "dashboard.adminTitle": "管理面板",
    "dashboard.adminNote": "请使用管理面板来管理平台。",
    "dashboard.adminButton": "前往管理面板",
    "dashboard.logVolunteerHours": "记录志愿时长",
    "dashboard.hideVolunteerHours": "隐藏志愿时长",
    "dashboard.viewMonthlyDonations": "查看月度捐赠",
    "dashboard.hideMonthlyDonations": "隐藏月度捐赠",
    "dashboard.walletSettings": "钱包设置",
    "dashboard.overview": "概览",
    "dashboard.lastUpdated": "最后更新",
    "dashboard.refreshData": "刷新数据",
    "dashboard.searchPlaceholder": "搜索项目、志愿者 (Cmd+K)",
    "dashboard.search": "搜索",

    // Settings - account section (GIV-254)
    "settings.manageDescription": "管理您的账户和偏好设置",
    "settings.account": "账户",
    "settings.email": "邮箱",
    "settings.displayName": "显示名称",
    "settings.authMethod": "认证方式",
    "settings.role": "角色",

    // Common additional (GIV-254)
    "common.refresh": "刷新",
    "common.all": "全部",
    "common.loading": "加载中...",
    "common.close": "关闭",
    "common.back": "返回",

    // Cause (GIV-254)
    "cause.createCause": "创建事业",

    // Contribution Tracker (GIV-254)
    "tracker.title": "全球影响力排名",
    "tracker.subtitle": "追踪和庆祝我们社区的集体影响",
    "tracker.searchPlaceholder": "搜索贡献者...",
    "tracker.exportCSV": "导出 CSV",
    "tracker.exportPDF": "导出 PDF",
    "tracker.hideContributions": "从排名中隐藏我的贡献",
    "tracker.yourAlias": "您的别名：",
    "tracker.changeAlias": "更改",
    "tracker.setWalletAlias": "设置钱包别名",
    "tracker.aliasTitle": "设置钱包别名",
    "tracker.aliasDescription":
      "您的别名将在贡献追踪中显示，替代您的钱包地址。",
    "tracker.aliasLabel": "别名",
    "tracker.aliasPlaceholder": "输入您的首选别名",
    "tracker.saveAlias": "保存别名",
    "tracker.donationRankings": "捐赠排名",
    "tracker.volunteerRankings": "志愿服务排名",
    "tracker.exportComplete": "导出完成",
    "tracker.exportDonationCSV": "捐赠排行榜已导出为 CSV",
    "tracker.exportVolunteerCSV": "志愿服务排行榜已导出为 CSV",
    "tracker.exportPDFSuccess": "排行榜已导出为 PDF",
    "tracker.exportFailed": "导出失败",
    "tracker.exportNoData": "没有可导出的数据",
    "tracker.exportError": "导出数据时发生错误",
    "tracker.walletNotConnected": "钱包未连接",
    "tracker.connectWalletForAlias": "请连接钱包以设置别名",
    "tracker.invalidAlias": "别名无效",
    "tracker.enterValidAlias": "请输入有效的别名",

    // Charity Portal (GIV-254)
    "charity.portal.deleteTitle": "删除{{type}}？",
    "charity.portal.deleteDescription":
      "此操作无法撤消。{{type}}将被永久删除。",
    "charity.portal.walletNotConfigured": "未配置接收钱包。",
    "charity.portal.walletDonationNote": "连接钱包以接收链上捐赠。",
    "charity.portal.setupWallet": "设置钱包",

    // Charity dashboard onboarding & verification
    "charity.onboarding.ariaLabel": "入驻清单",
    "charity.onboarding.title": "开始使用",
    "charity.onboarding.progress": "已完成 {{completed}}/{{total}} 步",
    "charity.onboarding.optional": "可选",
    "charity.onboarding.allComplete": "所有步骤已完成！您可以关闭此清单。",
    "charity.onboarding.expand": "展开清单",
    "charity.onboarding.collapse": "收起清单",
    "charity.onboarding.dismiss": "关闭入驻清单",
    "charity.onboarding.check": "勾选{{label}}",
    "charity.onboarding.uncheck": "取消勾选{{label}}",
    "charity.onboarding.stepDone": "{{label}}（已完成）",
    "charity.onboarding.stepAuto": "{{label}}（自动完成）",
    "charity.onboarding.goToOrganization": "前往组织",
    "charity.onboarding.setupWallet": "设置钱包",
    "charity.onboarding.item.completeProfile.label": "完善组织资料",
    "charity.onboarding.item.completeProfile.description":
      "添加您的组织名称、简介、地址和联系方式。",
    "charity.onboarding.item.uploadLogo.label": "上传徽标或横幅图片",
    "charity.onboarding.item.uploadLogo.description":
      "添加徽标或横幅，帮助捐赠者识别您的慈善机构。",
    "charity.onboarding.item.connectWallet.label": "设置收款钱包",
    "charity.onboarding.item.connectWallet.description":
      "选择多签 Safe、机构托管或单签名钱包来接收捐款，并通过签名消息证明您的控制权。",
    "charity.onboarding.item.bankDetails.label": "设置法币提现的银行信息",
    "charity.onboarding.item.bankDetails.description":
      "如需接受银行卡捐款，请配置银行信息。",
    "charity.onboarding.item.acceptTerms.label": "查看并接受服务条款",
    "charity.onboarding.item.acceptTerms.description":
      "阅读并确认 Give Protocol 慈善机构条款和条件。",
    "charity.verification.pendingTitle": "申请审核中",
    "charity.verification.pendingBody":
      "我们的团队正在审核您的慈善机构申请，通常需要 3–5 个工作日。作出决定后我们会通过电子邮件通知您。",
    "charity.verification.rejectedTitle": "申请未获批准",
    "charity.verification.reason": "原因：{{notes}}",
    "charity.verification.rejectedDefault": "您的申请暂未获批准。",
    "charity.verification.contactSupport": "联系支持",
    "charity.verification.suspendedTitle": "账户已被暂停",
    "charity.verification.suspendedDefault": "您的慈善机构账户已被暂停。",
    "charity.verification.appealSuspension": "申诉暂停",
    "charity.verification.verifiedTitle": "慈善机构已认证",
    "charity.verification.verifiedBody":
      "您的组织已通过认证，捐赠者现在可以支持您的项目。",
    "charity.portal.receivingWallet": "收款钱包：{{address}}",
    "charity.portal.loadError": "无法加载慈善机构数据，请重试。",

    // Timestamps (GIV-254)
    "timestamp.justNow": "刚刚",
    "timestamp.oneMinuteAgo": "1 分钟前",
    "timestamp.minutesAgo": "{{count}} 分钟前",

    // Common additions (GIV-256)
    "common.previous": "上一页",
    "common.next": "下一页",
    "common.pageOfTotal": "第 {{page}} 页，共 {{total}} 页",
    "common.retry": "重试",
    "common.processing": "处理中...",
    "common.saving": "保存中...",
    "common.donate": "捐赠",
    "common.active": "活跃",

    // Portfolio Funds - public page (GIV-256)
    "portfolio.donationType": "捐赠类型",
    "portfolio.devNative": "DEV（原生）",
    "portfolio.testToken": "TEST 代币",
    "portfolio.donationAmount": "捐赠金额：",
    "portfolio.platformFee": "平台费用（{{percentage}}%）：",
    "portfolio.toCharities": "给慈善机构：",
    "portfolio.eachCharityReceives": "每个慈善机构收到：",
    "portfolio.donateToFund": "捐赠给 {{name}}",
    "portfolio.equalDistribution": "均等分配",
    "portfolio.equalDistributionNote":
      "您的捐赠将在 {{count}} 个已验证慈善机构之间均等分配。",
    "portfolio.eachCharityPercentage": "每个慈善机构收到捐赠的 {{percentage}}%",
    "portfolio.verifiedCharities": "{{count}} 个已验证慈善机构",
    "portfolio.donateToFundButton": "捐赠给基金",
    "portfolio.noFundsAvailable": "暂无可用的投资组合基金",
    "portfolio.checkBackLater": "请稍后查看新的资助机会",
    "portfolio.amountLabel": "金额（{{currency}}）",
    "portfolio.invalidAmount": "请输入有效金额",
    "portfolio.donationSuccess": "捐赠成功！",
    "portfolio.donationFailed": "捐赠失败，请重试。",

    // Admin - Activity event type labels (GIV-256)
    "admin.activity.donation": "捐赠",
    "admin.activity.registration": "注册",
    "admin.activity.verification": "验证",
    "admin.activity.volunteerHours": "志愿时长",
    "admin.activity.default": "活动",

    // Admin - Dashboard page (GIV-256)
    "admin.dashboard.title": "管理面板",
    "admin.dashboard.alerts": "警报",
    "admin.dashboard.alertsPending": "{{count}} 个待处理",
    "admin.dashboard.alertsView": "查看",
    "admin.dashboard.recentActivity": "最近活动",
    "admin.dashboard.noRecentActivity": "没有最近活动。",
    "admin.dashboard.quickActions": "快捷操作",
    "admin.dashboard.errorTitle": "加载管理面板出错",
    "admin.stats.last7d": "近7天",
    "admin.stats.last30d": "近30天",
    "admin.stats.totalDonors": "捐赠者总数",
    "admin.stats.newRegistrations": "新注册",
    "admin.stats.charities": "慈善机构",
    "admin.stats.pendingVerification": "待验证",
    "admin.stats.verifiedCharities": "已验证慈善机构",
    "admin.stats.activeVolunteers": "活跃志愿者",
    "admin.stats.totalDonationVolume": "捐赠总额",
    "admin.stats.cryptoVolume": "加密货币交易额",
    "admin.stats.fiatVolume": "法币交易额",
    "admin.stats.donations": "笔捐赠",

    // Admin - Quick Actions (GIV-256)
    "admin.actions.viewReports": "查看报告",
    "admin.actions.viewReportsDesc": "生成详细分析报告",
    "admin.actions.manageCharities": "管理慈善机构",
    "admin.actions.manageCharitiesDesc": "审核和批准组织",
    "admin.actions.systemSettings": "系统设置",
    "admin.actions.systemSettingsDesc": "配置平台参数",
    "admin.actions.manageImpactMetrics": "管理影响力指标",
    "admin.actions.manageImpactMetricsDesc": "配置影响力计算器数据",
    "admin.actions.donationMonitoring": "捐赠监控",
    "admin.actions.donationMonitoringDesc": "监控、标记和报告捐赠",
    "admin.actions.contentModeration": "内容审核",
    "admin.actions.contentModerationDesc": "隐藏、标记和审核机会和事业",
    "admin.actions.portfolioFunds": "投资组合基金",
    "admin.actions.portfolioFundsDesc": "创建和管理精选捐赠组合",
    "admin.actions.charityRequests": "慈善机构请求",
    "admin.actions.charityRequestsDesc": "审核捐赠者对未注册慈善机构的请求",

    // Admin - Portfolio Funds management page (GIV-256)
    "admin.portfolio.title": "投资组合基金",
    "admin.portfolio.subtitle": "创建和管理精选捐赠组合",
    "admin.portfolio.newFund": "新基金",
    "admin.portfolio.editFund": "编辑基金",
    "admin.portfolio.createNewFund": "创建新基金",
    "admin.portfolio.fundName": "基金名称",
    "admin.portfolio.fundNamePlaceholder": "例如：环境影响基金",
    "admin.portfolio.description": "描述",
    "admin.portfolio.descriptionPlaceholder": "描述基金的目的和影响重点...",
    "admin.portfolio.category": "类别",
    "admin.portfolio.selectCategory": "选择类别",
    "admin.portfolio.imageUrl": "图片 URL",
    "admin.portfolio.imageUrlPlaceholder": "https://...",
    "admin.portfolio.selectCharities": "选择慈善机构（已选 {{count}} 个）",
    "admin.portfolio.noCharitiesFound": "未找到已验证的慈善机构",
    "admin.portfolio.saving": "保存中...",
    "admin.portfolio.createFund": "创建基金",
    "admin.portfolio.updateFund": "更新基金",
    "admin.portfolio.noFundsYet": "暂无投资组合基金",
    "admin.portfolio.noFundsMessage":
      "创建您的第一个基金，将慈善机构分组进行捐赠",
    "admin.portfolio.charity": "个慈善机构",
    "admin.portfolio.charities": "个慈善机构",
    "admin.portfolio.createdOn": "创建于 {{date}}",
    "admin.portfolio.statusActive": "活跃",
    "admin.portfolio.statusPaused": "已暂停",
    "admin.portfolio.statusArchived": "已归档",
    "admin.portfolio.errorLoad": "加载数据失败",
    "admin.portfolio.errorArchive": "归档基金失败",
    "admin.portfolio.fundArchived": "基金已归档",
    "admin.portfolio.fundUpdated": "基金已更新",
    "admin.portfolio.fundCreated": "基金已创建",
    "admin.portfolio.errorSave": "保存基金失败",

    // Admin - Charity Management page (GIV-256)
    "admin.charity.title": "慈善机构管理",
    "admin.charity.totalCount": "共 {{count}} 个",
    "admin.charity.allStatuses": "所有状态",
    "admin.charity.searchPlaceholder": "按名称搜索\u2026",
    "admin.charity.colName": "名称",
    "admin.charity.colEin": "税务编号",
    "admin.charity.taxIdDisplay": "税务编号 {{value}}",
    "admin.charity.searchByNameEin": "按名称或税务编号搜索…",
    "admin.charity.colCategory": "类别",
    "admin.charity.colStatus": "状态",
    "admin.charity.colSigner": "联系人",
    "admin.charity.colJoined": "加入时间",
    "admin.charity.colWallet": "钱包",
    "admin.charity.colActions": "操作",
    "admin.charity.walletNotSet": "未设置",
    "admin.charity.approve": "批准",
    "admin.charity.reject": "拒绝",
    "admin.charity.suspend": "暂停",
    "admin.charity.reinstate": "恢复",
    "admin.charity.statusPending": "待审核",
    "admin.charity.statusVerified": "已验证",
    "admin.charity.statusApproved": "已批准",
    "admin.charity.statusRejected": "已拒绝",
    "admin.charity.statusSuspended": "已暂停",
    "admin.charity.approveTitle": "批准慈善机构",
    "admin.charity.rejectTitle": "拒绝慈善机构",
    "admin.charity.suspendTitle": "暂停慈善机构",
    "admin.charity.reinstateTitle": "恢复慈善机构",
    "admin.charity.confirmAction": "确认操作",
    "admin.charity.reasonRequired": "原因（必填）",
    "admin.charity.reasonOptional": "原因（选填）",
    "admin.charity.saving": "保存中\u2026",
    "admin.charity.confirm": "确认",
    "admin.charity.noResults": "未找到符合筛选条件的慈善机构。",
    "admin.charity.unnamed": "未命名组织",

    // Admin - Charity Requests page (GIV-256)
    "admin.charityRequests.title": "慈善机构请求",
    "admin.charityRequests.subtitle":
      "捐赠者提交的未认领慈善机构请求，按组织分组。应优先联系关注度最高的组织。",
    "admin.charityRequests.ein": "税务编号",
    "admin.charityRequests.requests": "请求数",
    "admin.charityRequests.latestRequester": "最近请求者",
    "admin.charityRequests.latestRequest": "最近请求",
    "admin.charityRequests.firstRequest": "首次请求",
    "admin.charityRequests.empty": "尚未提交任何慈善机构请求。",
    "admin.charityRequests.errorTitle": "加载慈善机构请求出错",
    "admin.charityRequests.showing": "显示 {{shown}} / {{total}} 个唯一组织。",

    // Admin - Volunteer Validation page (GIV-256)
    "admin.validation.title": "志愿者验证监督",
    "admin.validation.totalCount": "共 {{count}} 个请求",
    "admin.validation.pipelineStats": "流水线统计",
    "admin.validation.noStats": "暂无统计数据。",
    "admin.validation.pending": "待处理",
    "admin.validation.approved": "已批准",
    "admin.validation.rejected": "已拒绝",
    "admin.validation.expired": "已过期",
    "admin.validation.avgResponseTime": "平均响应时间：",
    "admin.validation.expirationRate": "过期率：",
    "admin.validation.rejectionRate": "拒绝率：",
    "admin.validation.searchPlaceholder": "搜索志愿者、组织\u2026",
    "admin.validation.requestsTab": "验证请求",
    "admin.validation.patternsTab": "可疑模式",
    "admin.validation.colVolunteer": "志愿者",
    "admin.validation.colOrganisation": "组织",
    "admin.validation.colHours": "时长",
    "admin.validation.colActivityDate": "活动日期",
    "admin.validation.colHrsPerWeek": "时/周",
    "admin.validation.colTotalRequests": "请求总数",
    "admin.validation.override": "覆盖",
    "admin.validation.noPatterns": "未检测到可疑模式。",
    "admin.validation.noRequests": "未找到验证请求。",
    "admin.validation.patternsDescription":
      "标记在滚动7天窗口内报告超过配置阈值时长的志愿者。这些模式可能表明自行报告时长系统存在滥用。",
    "admin.validation.overrideTitle": "覆盖验证请求",
    "admin.validation.newStatus": "新状态",
    "admin.validation.reasonRequired": "原因（必填）",
    "admin.validation.reasonPlaceholder": "说明覆盖此请求的原因\u2026",
    "admin.validation.saving": "保存中\u2026",
    "admin.validation.confirmOverride": "确认覆盖",
    "admin.validation.allStatuses": "所有状态",
    "admin.validation.colStatus": "状态",
    "admin.validation.colCreated": "创建时间",

    // GIV-266: Delta translations (354 keys)
    "home.hero.title": "透明捐赠",
    "home.hero.titleAccent": "可持续影响力",
    "home.hero.description":
      "面向数字时代的透明公益。以影响力为导向，以可验证技术为支撑。每一笔捐赠从捐赠者到受益方全程可追溯。",
    "home.hero.visionTitle": "我们的愿景",
    "home.hero.visionText":
      "Give Protocol 致力于构建高诚信捐赠的未来。我们借助先进的技术基础设施，弥合全球资本与本地影响力之间的鸿沟。通过将无缝的数字资产支持与传统捐赠方式相融合，我们正在打造韧性十足的资助生态系统，将一次性捐赠转化为持续支持全球最关键事业的永续引擎。",
    "home.comingSoon": "即将推出",
    "home.readDocs": "阅读文档",
    "home.features.sectionTitle": "通往透明公益的入口",
    "home.features.sectionSubtitle":
      "多链基础设施，实现无缝捐赠——无论加密货币还是法币——全程透明",
    "home.features.highEfficiency.title": "高效捐赠",
    "home.features.highEfficiency.description":
      "直接向经过验证的机构捐赠，消除一切不确定性。我们的自动化账本提供实时验证，确保您的支持精准送达最需要的地方。",
    "home.features.equityFunds.title": "公益权益基金",
    "home.features.equityFunds.description":
      "超越一次性捐赠，通过智能管理的权益基金进行捐赠。我们运用成熟的低风险数字策略，将您的本金转化为源源不断的资助流，世代延续慈善使命。",
    "home.features.impactFunds.title": "影响力基金",
    "home.features.impactFunds.description":
      "汇聚资源，聚焦特定事业。环保、教育、扶贫——通过集体行动放大您的捐赠影响力。",
    "home.features.verifiedOrgs.title": "认证机构",
    "home.features.verifiedOrgs.description":
      "浏览任何已注册的机构，或查找认证标识。选择加入审核流程的机构将获得链上认证，值得捐赠者信赖。",
    "home.features.blockchainVerified.title": "区块链认证",
    "home.features.blockchainVerified.description":
      "灵魂绑定代币认可志愿者的贡献。技能、工时和影响力——全部永久记录在链上。",
    "home.features.bridgingModes.title": "桥接捐赠方式",
    "home.features.bridgingModes.description":
      "无论您使用美元还是数字资产捐赠，我们的多网络架构确保您的捐赠与现代世界同速运转。",
    "home.roles.title": "为每一位改变世界的人而建",
    "home.roles.donors.title": "捐赠者",
    "home.roles.donors.item1": "加密货币或法币捐赠——由您选择",
    "home.roles.donors.item2": "参与治理",
    "home.roles.donors.item3": "链上信誉建设",
    "home.roles.nonprofits.title": "非营利组织",
    "home.roles.nonprofits.item1": "触达全新捐赠群体",
    "home.roles.nonprofits.item2": "通过 CEF 实现可持续资助",
    "home.roles.nonprofits.item3": "增强透明度报告",
    "home.roles.volunteers.title": "志愿者",
    "home.roles.volunteers.item1": "可验证的贡献记录",
    "home.roles.volunteers.item2": "可携带的技能凭证（SBT）",
    "home.roles.volunteers.item3": "成就徽章与荣誉认可",
    "home.impact.title": "规划中的影响力基金",
    "home.impact.environmental.title": "环境影响力基金",
    "home.impact.environmental.description":
      "支持植树造林、海洋清洁和可再生能源计划。汇集捐赠定向支持经过验证的环保组织，产出可衡量的影响力。",
    "home.impact.education.title": "教育机会基金",
    "home.impact.education.description":
      "提供奖学金、数字学习工具和教师培训。汇聚集体力量，支持服务不足社区的教育事业。",
    "home.cta.title": "准备好变革捐赠方式了吗？",
    "home.cta.subtitle":
      "率先体验透明的区块链公益。加入我们的社区，共同为慈善捐赠构建更美好的未来。",
    "home.cta.explore": "探索公益事业",
    "home.nav.features": "功能",
    "home.nav.impact": "影响力",
    "home.nav.charities": "慈善机构",
    "home.nav.volunteer": "志愿服务",
    "home.footer.brand.tagline": "通过区块链透明度和可持续资助，变革公益事业。",
    "home.footer.product.title": "产品",
    "home.footer.product.impactFunds": "影响力基金",
    "home.footer.product.charities": "慈善机构专区",
    "home.footer.product.volunteers": "志愿者专区",
    "home.footer.resources.title": "资源",
    "home.footer.resources.whitepaper": "白皮书（即将推出）",
    "home.footer.resources.blog": "博客（即将推出）",
    "home.footer.resources.community": "社区（即将推出）",
    "home.footer.connect.title": "联系我们",
    "home.footer.connect.contact": "联系方式（即将推出）",
    "home.footer.copyright":
      "Give Protocol。多链设计。由 Give Protocol 志愿者驱动。",
    "auth.signin.welcomeBack": "欢迎回来",
    "auth.signin.subtitle": "登录您的 Give Protocol 账户",
    "auth.signin.emailPlaceholder": "电子邮箱",
    "auth.signin.passwordPlaceholder": "密码",
    "auth.signin.submitting": "正在登录…",
    "auth.signin.withPasskey": "使用通行密钥登录",
    "auth.signin.withGoogle": "通过 Google 继续",
    "auth.signin.or": "或",
    "auth.signin.newToProtocol": "初次使用 Give Protocol？",
    "auth.signin.createAccount": "创建账户 →",
    "auth.signin.forgotPasswordLink": "忘记密码？ →",
    "auth.signin.sslEncrypted": "TLS 加密",
    "auth.signin.modeToggleLabel": "登录方式",
    "auth.signin.terms": "条款",
    "auth.signin.privacy": "隐私",
    "auth.panel.headline": "智慧捐赠，透明影响。",
    "auth.panel.subheadline":
      "一个账户。银行卡或加密货币捐赠。每一分钱链上可追踪。",
    "auth.panel.statusLabel": "协议状态 · 创世阶段",
    "auth.panel.statusDesc": "正在构建透明捐赠的基础",
    "auth.panel.runsOn": "运行于",
    "auth.wallet.connect": "连接钱包",
    "auth.wallet.connecting": "正在连接钱包…",
    "auth.wallet.signing": "正在签名…",
    "auth.wallet.verifying": "正在验证…",
    "auth.wallet.openingSession": "正在开启会话…",
    "auth.validation.emailRequired": "请先输入您的电子邮箱地址",
    "auth.validation.invalidEmail": "请输入有效的电子邮箱地址",
    "auth.validation.passwordTooShort": "密码长度至少为 8 个字符",
    "auth.validation.passwordMismatch": "两次输入的密码不一致",
    "auth.login.welcomeHeading": "欢迎使用 Give Protocol",
    "auth.login.signInOrConnect": "登录或连接",
    "auth.login.skipToContent": "跳转到登录内容",
    "auth.login.donorTitle": "捐赠者登录",
    "auth.login.donorSubtitle": "登录以访问您的捐赠仪表盘",
    "auth.login.charityTitle": "非营利组织门户",
    "auth.login.charitySubtitle": "管理您的组织资料和捐赠信息",
    "auth.login.back": "← 返回",
    "auth.login.continueDonor": "以捐赠者身份继续",
    "auth.login.connecting": "正在连接…",
    "auth.login.connectWalletSignIn": "连接钱包并登录",
    "auth.login.newToPlatform": "初次使用 Give Protocol？",
    "auth.login.newDonorSignUp": "新捐赠者注册",
    "auth.login.manageNonprofit": "我管理一个非营利组织",
    "auth.login.nonprofitTrayTitle": "初次使用 Give Protocol？",
    "auth.login.createNonprofitAccount": "创建非营利组织账户",
    "auth.login.registerOrg": "在 Give Protocol 上注册您的组织",
    "auth.login.needHelp": "需要帮助？",
    "auth.login.forgotUsernameBtn": "忘记用户名？",
    "auth.login.forgotPasswordBtn": "忘记密码？",
    "auth.donorLogin.mismatch":
      "未找到捐赠者账户。此邮箱已注册为慈善机构账户，请使用慈善机构登录入口。",
    "auth.donorLogin.signingIn": "正在登录…",
    "auth.donorLogin.redirecting": "{{count}} 秒后跳转...",
    "auth.donorReg.pleaseWait": "请稍候…",
    "auth.donorReg.signUpPasskey": "使用通行密钥注册",
    "auth.donorReg.withGoogle": "通过 Google 继续",
    "auth.donorReg.connectWallet": "连接钱包",
    "auth.donorReg.orSetPassword": "或设置密码",
    "auth.donorReg.creating": "正在创建账户...",
    "auth.donorReg.createAccount": "创建捐赠者账户",
    "auth.donorReg.privacyNotice": "创建账户即表示您同意我们的",
    "auth.donorReg.termsLink": "服务条款",
    "auth.donorReg.privacyAnd": "并确认我们的",
    "auth.donorReg.privacyLink": "隐私政策",
    "auth.charityLogin.mismatch":
      "此邮箱已注册为捐赠者账户，请在捐赠者门户登录。",
    "auth.charityLogin.signingIn": "正在登录...",
    "auth.charityLogin.or": "或",
    "auth.charityLogin.connecting": "正在连接...",
    "auth.charityLogin.connectWallet": "连接钱包",
    "auth.forgot.resetPassword": "重置密码",
    "auth.forgot.forgotUsername": "找回用户名",
    "auth.forgot.passwordDesc":
      "请输入您的电子邮箱地址，我们将发送密码重置链接。",
    "auth.forgot.usernameDesc":
      "请输入您的电子邮箱地址，我们将发送您的用户名。",
    "auth.forgot.passwordSuccess": "密码重置说明已发送至您的邮箱",
    "auth.forgot.usernameSuccess": "用户名提醒已发送至您的邮箱",
    "auth.forgot.checkEmail": "请查看您的邮箱",
    "auth.forgot.backToSignIn": "返回登录",
    "auth.forgot.emailPlaceholder": "请输入您的电子邮箱地址",
    "auth.forgot.genericError": "发生错误，请重试。",
    "auth.forgot.sending": "正在发送...",
    "auth.forgot.sendResetLink": "发送重置链接",
    "auth.forgot.sendUsername": "发送用户名",

    // Reset password (set new password page) — pending translation (GIV-367)
    "auth.resetPassword.title": "Set New Password",
    "auth.resetPassword.subtitle": "Choose a strong password for your account.",
    "auth.resetPassword.newPassword": "New Password",
    "auth.resetPassword.confirmPassword": "Confirm New Password",
    "auth.resetPassword.submit": "Update Password",
    "auth.resetPassword.updating": "Updating\u2026",
    "auth.resetPassword.mismatch": "Passwords do not match.",
    "auth.resetPassword.success": "Password updated successfully!",
    "auth.resetPassword.successSubtitle":
      "You can now sign in with your new password.",
    "auth.resetPassword.backToSignIn": "Back to Sign In",
    "auth.resetPassword.invalidLink":
      "This password reset link is invalid or has expired.",
    "auth.resetPassword.requestNew": "Request a new reset link",
    "auth.resetPassword.validating": "Validating reset link\u2026",
    "auth.orgSearch.orgNameLabel": "组织名称",
    "auth.orgSearch.searchPlaceholder": "按组织名称搜索...",
    "auth.orgSearch.countryLabel": "国家/地区",
    "auth.orgSearch.allCountries": "所有国家/地区",
    "auth.orgSearch.searchPrompt": "搜索我们的数据库，查找并认领您的组织。",
    "auth.orgSearch.noResults": "未找到相关组织。",
    "auth.orgSearch.loadMore": "加载更多结果",
    "auth.orgSearch.cantFind": "找不到您的组织？",
    "auth.orgSearch.registerManually": "手动注册",
    "charity.claim.orgDetails": "组织详情（来自注册信息）",
    "charity.claim.orgNameLabel": "名称",
    "charity.claim.einLabel": "税务编号",
    "charity.claim.locationLabel": "所在地",
    "charity.claim.contactInfo": "联系信息",
    "charity.claim.contactName": "联系人姓名",
    "charity.claim.contactEmail": "联系邮箱",
    "charity.claim.accountSecurity": "账户安全",
    "charity.claim.password": "密码",
    "charity.claim.confirmPassword": "确认密码",
    "charity.claim.backToSearch": "返回搜索",
    "charity.claim.creating": "正在创建账户...",
    "charity.claim.submit": "认领组织",
    "charity.claim.validation.name": "名称须在 2 到 100 个字符之间",
    "charity.claim.validation.email": "请输入有效的电子邮箱地址",
    "charity.claim.validation.password": "密码长度至少为 8 个字符",
    "charity.claim.validation.confirmPassword": "两次输入的密码不一致",
    "charity.claim.validation.fix": "请更正验证错误",
    "charity.claim.useAsPublicEmail": "使用我的电子邮件作为组织的公开联系邮箱",
    "charity.claim.publicContactEmail": "组织公开联系邮箱",
    "charity.claim.privacyNotice":
      "您的个人签署人邮箱/电话仅用于验证，其他平台用户无法看到。公开联系邮箱将显示在您的组织简介中。",
    "charity.claim.secondContactTitle": "第二联系人",
    "charity.claim.secondContactName": "第二联系人姓名",
    "charity.claim.secondContactEmail": "第二联系人电子邮件",
    "charity.claim.secondContactHint":
      "另一位联系人，当您慈善机构的钱包或收款详情发生变更时接收通知。",
    "charity.claim.validation.secondEmailDistinct":
      "第二联系人电子邮件必须与主电子邮件不同",
    "charity.claim.error.creation": "账户创建失败",
    "charity.claim.error.generic": "创建账户失败",
    "charity.vetting.orgDetails": "组织详情",
    "charity.vetting.orgName": "组织名称",
    "charity.vetting.description": "描述",
    "charity.vetting.taxId": "税务登记号",
    "charity.vetting.countryLabel": "国家/地区",
    "charity.vetting.selectCountry": "选择国家/地区",
    "charity.vetting.address": "地址",
    "charity.vetting.streetAddress": "街道地址",
    "charity.vetting.city": "城市",
    "charity.vetting.state": "省/州",
    "charity.vetting.postalCode": "邮政编码",
    "charity.vetting.contactInfo": "联系信息",
    "charity.vetting.contactName": "联系人姓名",
    "charity.vetting.contactEmail": "联系邮箱",
    "charity.vetting.accountSecurity": "账户安全",
    "charity.vetting.password": "密码",
    "charity.vetting.confirmPassword": "确认密码",
    "charity.vetting.submitting": "正在提交申请...",
    "charity.vetting.submit": "提交慈善机构申请",
    "charity.vetting.validation.orgName": "组织名称须在 2 到 100 个字符之间",
    "charity.vetting.validation.contactName":
      "联系人姓名须在 2 到 100 个字符之间",
    "charity.vetting.validation.email": "请输入有效的电子邮箱地址",
    "charity.vetting.validation.password": "密码长度至少为 8 个字符",
    "charity.vetting.validation.confirmPassword": "两次输入的密码不一致",
    "charity.vetting.validation.description": "描述为必填项",
    "charity.vetting.validation.category": "类别为必填项",
    "charity.vetting.validation.taxId": "税务登记号为必填项",
    "charity.vetting.validation.streetAddress": "街道地址为必填项",
    "charity.vetting.validation.city": "城市为必填项",
    "charity.vetting.validation.country": "国家/地区为必填项",
    "charity.vetting.validation.fix": "请更正验证错误",
    "charity.vetting.error.generic": "提交申请失败",
    "charity.vetting.privacyNotice": "提交此申请即表示您同意我们的",
    "charity.vetting.termsLink": "服务条款",
    "charity.vetting.privacyAnd": "并确认我们的",
    "charity.vetting.privacyLink": "隐私政策",
    "common.email": "电子邮箱",
    "common.password": "密码",
    "common.confirmPassword": "确认密码",
    "footer.brand.tagline": "消除可持续慈善捐赠的障碍。",
    "footer.resources.title": "资源",
    "footer.resources.faq": "常见问题",
    "footer.resources.about": "关于我们",
    "footer.legal.title": "法律信息",
    "footer.legal.terms": "服务条款",
    "footer.legal.privacy": "隐私政策",
    "footer.legal.cookiePreferences": "Cookie 偏好设置",
    "consent.banner.ariaLabel": "Cookie 同意",
    "consent.banner.body":
      "我们使用 Google Analytics 4（Google LLC，美国）和 Sentry（Functional Software，美国/欧盟）来了解应用的使用情况并检测错误。不会共享任何电子邮件地址、钱包地址或捐赠者姓名。您可以随时撤回同意。",
    "consent.banner.privacyLink": "隐私政策",
    "consent.banner.acceptAll": "全部接受",
    "consent.banner.decline": "拒绝非必要",
    "consent.banner.customize": "自定义",
    "consent.modal.title": "Cookie 偏好设置",
    "consent.modal.essentialTitle": "必要",
    "consent.modal.essentialDesc":
      "网站核心功能（如导航和身份验证）所必需。无法禁用。",
    "consent.modal.essentialAlwaysOn": "必要 Cookie — 始终启用",
    "consent.modal.analyticsTitle":
      "分析（Google Analytics 4 · 美国，Sentry · 美国/欧盟）",
    "consent.modal.analyticsDesc":
      "分析 Cookie 帮助我们了解哪些页面被访问以及用户如何在应用中导航。我们使用 Google Analytics 4 \u2014 会话标识符、页面 URL、设备/浏览器元数据、从匿名化 IP 获取的大致位置（Google LLC，美国；SCCs + EU\u2013US Data Privacy Framework）。Sentry \u2014 用于可靠性监控的匿名化错误跟踪和浏览器元数据（Functional Software，欧盟/美国；传输机制待定）。不会与任何处理者共享电子邮件地址、钱包地址或捐赠者姓名。",
    "consent.modal.analyticsOn": "分析与错误记录 — 已开启",
    "consent.modal.analyticsOff": "分析与错误记录 — 已关闭",
    "consent.modal.cancel": "取消",
    "consent.modal.save": "保存偏好设置",
    "footer.connect.title": "联系我们",
    "footer.copyright": "Give Protocol。保留所有权利。",
    "nav.signIn": "登录",
    "nav.signOut": "退出登录",
    "nav.privacy": "隐私",
    "auth.signup.heading": "创建您的账户",
    "auth.signup.subtitle": "加入透明捐赠运动",
    "auth.signup.displayName": "显示名称",
    "auth.signup.emailPlaceholder": "电子邮箱",
    "auth.signup.passwordPlaceholder": "密码",
    "auth.signup.confirmPasswordPlaceholder": "确认密码",
    "auth.signup.submit": "创建账户",
    "auth.signup.submitting": "正在创建账户…",
    "auth.signup.withPasskey": "使用通行密钥注册",
    "auth.signup.withGoogle": "通过 Google 继续",
    "auth.signup.connectWallet": "连接钱包",
    "auth.signup.orSetPassword": "或设置密码",
    "auth.signup.alreadyHaveAccount": "已有账户？",
    "auth.signup.signInLink": "登录",
    "auth.signup.manageNonprofit": "管理非营利组织？",
    "auth.signup.trustText": "您的数据受到以下保护",
    "auth.signup.and": "和",
    "auth.signup.privacyPolicy": "隐私政策",
    "auth.signup.panel.headline": "可验证的捐赠。",
    "browse.hero.title": "链上验证的捐赠。",
    "browse.hero.subtitle":
      "发现经过筛选的事业，通过银行卡或数字资产捐款，并看到你的时间和资源带来的切实影响。",
    "browse.stats.networks": "支持的网络",
    "browse.stats.sectors": "慈善领域",
    "browse.stats.verifiedOrgs": "已认证组织",
    "browse.stats.volunteerHours": "志愿服务时长",
    "browse.verified": "已认证",
    "browse.donate": "捐赠",
    "browse.viewProfile": "查看档案",
    "browse.filter.ariaLabel": "筛选慈善机构",
    "browse.filter.searchAria": "搜索慈善机构",
    "browse.filter.locationAria": "搜索地区",
    "browse.results.ariaLabel": "慈善机构结果",
    "browse.tabs.charities": "慈善机构",
    "browse.tabs.causes": "公益事业",
    "browse.tabs.funds": "投资组合基金",
    "browse.tabs.ariaLabel": "浏览分类",
    "browse.featured.heading": "推荐组织",
    "browse.featured.ariaLabel": "推荐组织",
    "browse.featured.nextAria": "下一批推荐组织",
    "browse.causes.heading": "推荐公益事业",
    "browse.causes.ariaLabel": "推荐公益事业",
    "browse.causes.badge": "公益事业",
    "browse.causes.raised": "已筹集",
    "browse.causes.percentOf": "% 的",
    "browse.causes.by": "发起方",
    "browse.causes.supportCta": "支持此项事业",
    "browse.causes.giveCta": "捐赠",
    "browse.causes.nextAria": "下一批推荐公益事业",
    "browse.funds.heading": "投资组合基金",
    "browse.funds.ariaLabel": "投资组合基金",
    "browse.funds.badge": "投资组合基金",
    "browse.funds.charity": "个慈善机构",
    "browse.funds.charities": "个慈善机构",
    "browse.funds.donateCta": "向基金捐赠",
    "browse.funds.nextAria": "下一批投资组合基金",
    "portfolio.notFound.title": "未找到投资组合基金",
    "portfolio.notFound.body": "您查找的投资组合基金不存在或已不再活跃。",
    "portfolio.supportedOrgs": "支持的机构",
    "browse.charity.einLabel": "税务编号",
    "browse.charity.einDisplay": "税务编号：{{value}}",
    "browse.charity.nteeLabel": "行业代码",
    "browse.charity.deductibilityLabel": "可抵扣性",
    "browse.charity.onPlatform": "已入驻平台",
    "browse.charity.loading": "加载中…",
    "browse.charity.loadMore": "加载更多",
    "browse.filter.searchPlaceholder": "搜索慈善机构...",
    "browse.filter.locationPlaceholder": "城市、省份或国家...",
    "browse.whyGiveProtocol.heading": "为什么选择 Give Protocol？",
    "browse.whyGiveProtocol.verified.title": "经过验证的非营利组织",
    "browse.whyGiveProtocol.verified.description":
      "每个组织在出现在平台上之前都会与公共注册信息进行核实。",
    "browse.whyGiveProtocol.onchain.title": "链上透明度",
    "browse.whyGiveProtocol.onchain.description":
      "捐款记录在区块链上，让您可以从钱包到公益事业全程追踪您的影响。",
    "browse.whyGiveProtocol.volunteer.title": "捐出时间，不只是金钱",
    "browse.whyGiveProtocol.volunteer.description":
      "志愿服务时间由慈善机构验证，并计入您的协议声誉。",
    "browse.news.heading": "平台动态",
    "admin.news.deleteConfirmBody": "“{{title}}”将被永久删除，此操作无法撤销。",
    "admin.news.deleteConfirmTitle": "删除这条动态？",
    "admin.news.saveFailed": "无法保存您的更改，请重试。",
    "admin.news.urlHelp": "可选。留空则显示不带链接的动态。",
    "admin.news.urlInvalid": "请输入完整的 https:// 地址，或以 / 开头的路径。",
    "browse.carousel.error": "无法加载此部分，请刷新页面后重试。",
    "browse.carousel.goToPage": "转到第 {{page}} 页",
    "browse.carousel.pageLabel": "第 {{current}} 页，共 {{total}} 页",
    "browse.carousel.pause": "暂停自动轮播",
    "browse.carousel.play": "恢复自动轮播",
    "browse.causes.empty": "暂无公益事业，请稍后再来查看！",
    "browse.causes.prevAria": "上一组精选公益事业",
    "browse.causes.searchPlaceholder": "搜索公益事业...",
    "browse.causes.subheading": "支持能够产生实际影响的具体项目。",
    "browse.charity.registryIdDisplay": "登记编号：{{value}}",
    "browse.featured.empty": "暂无精选机构。请使用上方搜索查找慈善机构。",
    "browse.featured.prevAria": "上一组精选机构",
    "browse.featured.subheading": "轮播展示 Give Protocol 上已验证的慈善机构。",
    "browse.filter.addLocation": "添加地点",
    "browse.filter.impactNotice": "影响地区筛选暂不可用，因此结果不会按影响地区缩小范围。",
    "browse.filter.locationHint": "按 Enter 键或选择“添加”以应用地点。",
    "browse.filter.minChars": "请至少输入 2 个字符进行搜索。",
    "browse.funds.empty": "暂无投资组合基金，请稍后再来查看！",
    "browse.funds.prevAria": "上一组投资组合基金",
    "browse.funds.searchPlaceholder": "搜索投资组合基金...",
    "browse.funds.subheading": "精选的捐赠组合，将捐款分配给已验证的慈善机构。",
    "browse.registry.badge": "已在{{registry}}登记",
    "browse.results.empty": "没有符合该搜索的机构。请尝试其他关键词或添加地点筛选。",
    "browse.results.error": "无法执行该搜索，请重试。",
    "browse.search.noMatches": "没有与“{{query}}”匹配的内容。",
    "browse.category.A": "艺术与文化",
    "browse.category.B": "教育",
    "browse.category.C": "环境",
    "browse.category.D": "动物福利",
    "browse.category.E": "健康",
    "browse.category.F": "心理健康",
    "browse.category.G": "医学研究",
    "browse.category.H": "生物医学研究",
    "browse.category.I": "犯罪与法律",
    "browse.category.J": "就业",
    "browse.category.K": "食品与营养",
    "browse.category.L": "住房",
    "browse.category.M": "公共安全",
    "browse.category.N": "休闲娱乐",
    "browse.category.O": "青少年发展",
    "browse.category.P": "人类服务",
    "browse.category.Q": "国际",
    "browse.category.R": "公民权利",
    "browse.category.S": "社区发展",
    "browse.category.T": "慈善事业",
    "browse.category.U": "科学与技术",
    "browse.category.V": "社会科学",
    "browse.category.W": "公共政策",
    "browse.category.X": "宗教",
    "browse.category.Y": "互助",
    "browse.category.default": "非营利组织",
    "cause.causes": "公益事业",
    "cause.createNew": "新建",
    "cause.noCausesTitle": "暂无公益事业",
    "cause.name": "名称",
    "cause.description": "描述",
    "cause.category": "类别",
    "cause.targetAmount": "目标金额",
    "cause.headerImage": "头图",
    "cause.impact": "影响力",
    "cause.impactHelp": "描述此项公益事业的预期影响。",
    "cause.location": "地区",
    "cause.timeline": "时间线",
    "cause.partners": "合作伙伴",
    "cause.limitReached": "已达公益事业数量上限",
    "impact.statistics": "影响力统计",
    "impact.statLabel": "标签",
    "impact.statValue": "数值",
    "impact.missionStatement": "使命宣言",
    "impact.missionPlaceholder": "我们的使命是……",
    "impact.highlights": "影响力亮点",
    "impact.highlight": "影响力亮点",
    "impact.addHighlight": "添加亮点",
    "impact.profile": "影响力档案",
    "impact.loadError": "加载影响力档案失败",
    "impact.saveError": "保存影响力档案失败",
    "impact.saveSuccess": "影响力档案保存成功",
    "organization.yearFounded": "成立年份",
    "organization.address": "地址",
    "organization.street": "街道地址",
    "organization.city": "城市",
    "organization.stateProvince": "省/州",
    "organization.postalCode": "邮政编码",
    "organization.country": "国家/地区",
    "organization.contactInfo": "联系信息",
    "organization.phone": "电话",
    "organization.email": "电子邮箱",
    "organization.website": "网站",
    "organization.socialMedia": "社交媒体",
    "organization.publicFeed": "公共动态",
    "organization.communityMedia": "社区与媒体",
    "organization.profile": "组织档案",
    "organization.loadError": "加载组织档案失败",
    "organization.saveError": "保存组织档案失败",
    "common.remove": "移除",
    "common.saveChanges": "保存更改",
    "dashboard.thisMonth": "本月",
    "dashboard.verified": "已认证志愿者",
    "dashboard.hoursLogged": "已记录工时",
    "dashboard.endorsements": "推荐认可",
    "dashboard.organizationsHelped": "受助组织",
    "dashboard.yourOrganizationsHelped": "您帮助的组织",
    "transactions.createCampaign": "创建您的第一个募捐活动",
    "contributions.emptyTitle": "您的捐赠旅程从这里开始",
    "contributions.browseCharities": "浏览慈善机构",
    "charity.profile.verified501c3": "已认证非营利组织",
    "charity.profile.verified501c3Tooltip":
      "已注册 501(c)(3) — 在美国捐款可能可以抵扣税款",
    "charity.profile.statusClaimed": "已认领",
    "charity.profile.statusUnclaimed": "未认领 — 仅含公共登记数据",
    "charity.profile.statusIrsVerified": "IRS已认证非营利组织",
    "charity.profile.requestWidget.unclaimedBody":
      "该组织尚未在 Give Protocol 上认领其主页。该组织完成主页认领和钱包设置后，即可接受捐赠。",
    "charity.profile.rowEin": "税务编号",
    "charity.profile.rowName": "名称",
    "charity.profile.rowLocation": "所在地",
    "charity.profile.rowRulingYear": "注册年份",
    "charity.profile.rowNteeCode": "行业代码",
    "charity.profile.rowDeductibility": "可抵扣性",
    "charity.profile.rowAffiliation": "隶属关系",
    "charity.profile.rowClassification": "分类",
    "charity.profile.rowFoundation": "基金会类型",
    "charity.profile.rowActivityCodes": "活动代码",
    "charity.profile.rowOrgType": "组织类型",
    "charity.profile.rowSubsection": "条款分节",
    "charity.profile.rowStatus": "状态",
    "charity.profile.registryRecord": "注册公开记录",
    "charity.profile.einDisplay": "税务编号",
    "charity.profile.charityNotFoundByTaxId":
      "我们未找到使用此税务编号的慈善机构。",
    "charity.profile.registeredNonprofit": "已注册非营利组织",
    "charity.profile.registeredYear": "注册于 {{year}} 年",
    "charity.profile.shareAria": "分享",
    "charity.profile.copied": "已复制！",
    "charity.profile.about": "关于",
    "charity.profile.claimProfile": "认领此档案",
    "charity.profile.noDescription": "暂无描述。",
    "charity.profile.toAddOne": "添加描述。",
    "charity.profile.contact": "联系方式",
    "charity.profile.donate.support": "支持",
    "charity.profile.donate.walletUnset": "该组织尚未设置官方接收钱包。",
    "charity.profile.donate.walletPending":
      "该组织正在完成钱包设置 — 捐款暂时不可用。",
    "charity.profile.donate.walletLegacy": "该组织正在使用旧版钱包地址。",
    "charity.profile.donate.feeNote": "直接捐款平台费用为0%。适用网络费用。",
    "charity.profile.donate.jurisdictionUnavailable":
      "Give Protocol 目前暂不支持对美国以外慈善机构的捐赠。",
    "portfolio.title": "投资组合基金",
    "settings.displayPreferences": "显示偏好",
    "settings.theme": "主题",
    "settings.light": "浅色",
    "settings.dark": "深色",
    "auth.toast.welcomeBack": "Welcome back, {{firstName}}",
    "auth.toast.youreSignedIn": "You're signed in.",
    "auth.toast.walletConnected": "Wallet connected",
    "auth.toast.signedInWith": "Signed in with {{address}}.",
    "auth.toast.signedOut": "Signed out",
    "auth.toast.signInFailed": "Sign-in failed",
    "auth.toast.signOutFailed": "Sign-out failed",
    "donation.toast.received": "Donation received",
    "donation.toast.receivedMessage":
      "Thank you — your tax receipt is on the way.",
    "donation.toast.submitted": "Transaction submitted",
    "donation.toast.submittedMessage": "Waiting for on-chain confirmation…",
    "donation.toast.confirmed": "Donation confirmed",
    "donation.toast.confirmedMessage":
      "Your contribution is recorded on-chain.",
    "donation.toast.failed": "Donation failed",

    // Art. 9(2)(a) donation consent (GIV-655)
    "donation.art9Consent.statement":
      "我理解我的捐赠记录将我与{{charity}}关联。如果这可能表明宗教、政治或哲学方面的归属关系，我明确同意Give Protocol处理此记录以完成和管理我的捐赠。",
    "donation.art9Consent.label": "捐赠数据同意",
    "donation.art9Consent.required": "您必须同意捐赠数据处理才能继续。",

    "charity.toast.verificationEmailSent": "Verification email sent",
    "charity.toast.verificationEmailMessage":
      "Check your inbox — the link expires in 24 hours.",
    "charity.toast.submissionFailed": "Submission failed",

    "privacy.security.auditLog":
      "作为GDPR第32条规定的技术措施，我们记录并监控对个人数据的管理访问——包括所执行的操作及其发生时间——以检测未经授权的访问、证明问责制，并在万一发生个人数据泄露（第34条）时重建事件。捐赠者的个人数据不会被复制到这些管理访问日志中。管理访问日志与§7.1中描述的身份验证和安全日志不同；其保留期限由我们的内部处理活动记录管理。",

    // Remaining i18n keys — batch translation
    "admin.auditTrail.filterByAction": "按操作筛选",
    "admin.auditTrail.allActions": "所有操作",
    "admin.auditTrail.action.charityStatusChange": "慈善机构状态变更",
    "admin.auditTrail.action.userStatusChange": "用户状态变更",
    "admin.auditTrail.action.donationFlag": "捐赠标记",
    "admin.auditTrail.action.donationFlagResolve": "捐赠标记解决",
    "admin.auditTrail.action.validationOverride": "验证覆盖",
    "admin.auditTrail.action.configChange": "配置变更",
    "admin.auditTrail.action.verificationApprove": "验证批准",
    "admin.auditTrail.action.verificationReject": "验证拒绝",
    "admin.auditTrail.action.charitySuspend": "慈善机构暂停",
    "admin.auditTrail.action.charityReinstate": "慈善机构恢复",
    "admin.auditTrail.action.userSuspend": "用户暂停",
    "admin.auditTrail.action.userReinstate": "用户恢复",
    "admin.auditTrail.action.userBan": "用户封禁",
    "admin.auditTrail.action.viewPii": "查看PII",
    "admin.auditTrail.action.viewPiiList": "查看PII列表",
    "admin.auditTrail.viewedEntity":
      "管理员{{adminId}}查看了{{entityType}} {{entityId}}",
    "admin.auditTrail.viewedList":
      "管理员{{adminId}}查看了{{entityType}}列表（第{{page}}页，筛选条件：{{filters}}）",
    "admin.auditTrail.viewedListNoFilters":
      "管理员{{adminId}}查看了{{entityType}}列表（第{{page}}页）",
    "admin.actions.platformNews": "平台新闻",
    "admin.actions.platformNewsDesc": "管理浏览页面上的新闻项目",
    "admin.news.activate": "激活{{title}}",
    "admin.news.activated": "新闻项目已发布",
    "admin.news.activeLabel": "已发布（公开可见）",
    "admin.news.categoryLabel": "分类",
    "admin.news.contentLabel": "内容/摘要",
    "admin.news.contentPlaceholder": "新闻项目的简要说明……",
    "admin.news.createNews": "创建新闻项目",
    "admin.news.createNewsBtn": "创建新闻",
    "admin.news.created": "新闻项目已创建",
    "admin.news.dateLabel": "发布日期",
    "admin.news.deactivate": "停用{{title}}",
    "admin.news.deactivated": "新闻项目已隐藏",
    "admin.news.deleteItem": "删除{{title}}",
    "admin.news.deleted": "新闻项目已删除",
    "admin.news.editItem": "编辑{{title}}",
    "admin.news.editNews": "编辑新闻项目",
    "admin.news.imageLabel": "图片URL（可选）",
    "admin.news.imagePlaceholder": "https://...",
    "admin.news.inactive": "未激活",
    "admin.news.newItem": "新建项目",
    "admin.news.noItemsMessage": "创建您的第一个新闻项目，与社区分享最新动态",
    "admin.news.noItemsYet": "暂无新闻项目",
    "admin.news.publishedOn": "发布于{{date}}",
    "admin.news.saving": "保存中……",
    "admin.news.subtitle": "管理公开浏览页面上显示的新闻项目",
    "admin.news.title": "平台新闻",
    "admin.news.titleLabel": "标题",
    "admin.news.titlePlaceholder": "例如：季度影响力报告",
    "admin.news.updateNews": "更新新闻",
    "admin.news.updated": "新闻项目已更新",
    "admin.news.urlLabel": "链接URL",
    "admin.news.urlPlaceholder": "https://example.org/article",
    "charity.walletBadge.institutionalLabel": "托管于{{custodianName}}",
    "charity.walletBadge.institutionalTooltip":
      "捐款将进入由合格机构托管方持有的钱包。",
    "charity.walletBadge.safeLabel": "多签国库 · {{threshold}}/{{count}}签署人",
    "charity.walletBadge.safeTooltip":
      "捐款将进入需要多个批准才能转移资金的多重签名钱包。",
    "wallet.eoa.chain": "网络",
    "wallet.eoa.checkAuthorized":
      "我已获得所在组织的授权，可将此钱包指定为接收慈善捐款的地址。",
    "wallet.eoa.checkRisk":
      "我理解单签钱包的风险高于多签钱包，且私钥丢失将导致资金永久丢失。",
    "wallet.eoa.confirmSubtitle": "在注册此钱包之前，请确认以下事项。",
    "wallet.eoa.confirmTitle": "最终确认",
    "wallet.eoa.connectFirst": "请先连接您的钱包。",
    "wallet.eoa.connectWallet": "连接钱包",
    "wallet.eoa.missingSignature": "缺少签名。请返回并重新签名。",
    "wallet.eoa.proceedAnyway": "我已了解，继续",
    "wallet.eoa.register": "注册钱包",
    "wallet.eoa.registering": "注册中……",
    "wallet.eoa.rejected": "签名请求已被拒绝。",
    "wallet.eoa.riskParagraph1":
      "单签（EOA）钱包由一个私钥控制。如果该私钥丢失、被盗或被泄露，发送到此钱包的所有资金将永久无法找回。",
    "wallet.eoa.riskParagraph2":
      "对于组织资金，我们强烈建议改用多签Safe钱包。多签钱包的每笔交易都需要多个批准，可防止单点故障。",
    "wallet.eoa.riskParagraph3":
      "继续操作即表示您确认，Give Protocol对因私钥泄露、丢失或管理不当而造成的任何资金损失概不负责。",
    "wallet.eoa.riskTitle": "单签钱包：重要风险提示",
    "wallet.eoa.signError": "签名消息失败，请重试。",
    "wallet.eoa.signMessage": "签署验证消息",
    "wallet.eoa.signSubtitle":
      "连接您的钱包并签署一条消息，以证明您控制此地址。",
    "wallet.eoa.signTitle": "连接并签名",
    "wallet.eoa.useMultisig": "改用多签钱包",
    "wallet.eoa.walletConnection": "钱包",
    "wallet.eoa.walletToRegister": "待注册钱包",
    "wallet.institutional.address": "钱包地址",
    "wallet.institutional.attestation": "证明文件",
    "wallet.institutional.attestationHelp":
      "上传PDF、JPEG或PNG文件（最大10MB），以证明您的托管关系。",
    "wallet.institutional.backToWallets": "返回钱包列表",
    "wallet.institutional.chain": "网络",
    "wallet.institutional.chooseFile": "选择文件或拖放到此处",
    "wallet.institutional.custodian": "托管方",
    "wallet.institutional.fileTooLarge": "文件大小必须小于10MB。",
    "wallet.institutional.invalidAddress": "请输入有效的以太坊地址（0x...）",
    "wallet.institutional.invalidFileType": "请上传PDF、JPEG或PNG文件。",
    "wallet.institutional.removeFile": "移除文件",
    "wallet.institutional.selectCustodian": "请选择托管方。",
    "wallet.institutional.selectCustodianOption": "选择托管方……",
    "wallet.institutional.submit": "提交审核",
    "wallet.institutional.submittedDesc":
      "您的机构钱包注册正在审核中。您将在3个工作日内收到电子邮件通知。",
    "wallet.institutional.submittedTitle": "钱包已提交审核",
    "wallet.institutional.submitting": "提交中……",
    "wallet.institutional.subtitle":
      "提供由托管方管理的钱包详细信息，并上传证明文件以供验证。",
    "wallet.institutional.title": "注册机构托管钱包",
    "wallet.institutional.uploadFile": "上传证明文件",
    "wallet.institutional.uploadRequired": "请上传证明文件。",
    "wallet.safe.address": "Safe地址",
    "wallet.safe.chain": "网络",
    "wallet.safe.connectFirst": "请先连接您的签署钱包。",
    "wallet.safe.connectSigner": "连接签署钱包",
    "wallet.safe.createNew": "创建新的Safe",
    "wallet.safe.createNewDesc":
      "打开app.safe.global，您可以在其中创建新的多签钱包。部署完成后请返回此处。",
    "wallet.safe.haveOne": "我已经有Safe钱包",
    "wallet.safe.haveOneDesc":
      "输入您的Safe地址，并通过签署人钱包签署消息以验证控制权。",
    "wallet.safe.invalidAddress": "请输入有效的以太坊地址（0x...）",
    "wallet.safe.rejected": "签名请求已被拒绝。",
    "wallet.safe.signError": "签署验证消息失败，请重试。",
    "wallet.safe.signVerify": "签署以验证控制权",
    "wallet.safe.signerWallet": "签署钱包",
    "wallet.safe.subtitle":
      "Safe需要多个签署人批准每笔交易，为您的慈善机构资金提供最高级别的安全保障。",
    "wallet.safe.title": "设置Safe多签钱包",
    "wallet.safe.verifyTitle": "验证Safe所有权",
    "wallet.safe.verifying": "验证中……",
    "wallet.setup.addAnother": "添加另一个",
    "wallet.setup.custodian": "托管方",
    "wallet.setup.deleteFailed": "移除钱包失败",
    "wallet.setup.eoaDesc":
      "由单一私钥控制的标准钱包。最简单，但对组织使用而言安全性最低。",
    "wallet.setup.eoaTitle": "单签（EOA）",
    "wallet.setup.institutionalDesc":
      "由合格托管方（Fireblocks、Anchorage等）管理。需要证明文件。",
    "wallet.setup.institutionalTitle": "机构托管",
    "wallet.setup.makePrimary": "设为主钱包",
    "wallet.setup.primary": "主钱包",
    "wallet.setup.primaryFailed": "更新主钱包失败",
    "wallet.setup.primaryUpdated": "主钱包已更新",
    "wallet.setup.recommended": "推荐",
    "wallet.setup.remove": "移除钱包",
    "wallet.setup.safeDesc":
      "每笔交易均需多个签署人批准。为组织资金提供最高安全性。",
    "wallet.setup.safeSigners": "签署人",
    "wallet.setup.safeTitle": "多签Safe",
    "wallet.setup.subtitle":
      "选择您的慈善机构接收加密货币捐款的方式。我们建议使用多签钱包以获得最高安全性。",
    "wallet.setup.title": "设置您的接收钱包",
    "wallet.setup.viewExplorer": "在区块浏览器中查看",
    "wallet.setup.walletAdded": "钱包注册成功",
    "wallet.setup.walletDeleted": "钱包已移除",
    "wallet.setup.walletsTitle": "接收钱包",
    "admin.nav.dashboard": "仪表板",
    "admin.nav.reports": "报告与分析",
    "admin.nav.charities": "慈善机构",
    "admin.nav.donations": "捐款",
    "admin.nav.impactMetrics": "影响力指标",
    "admin.nav.portfolioFunds": "投资组合基金",
    "admin.nav.contentModeration": "内容审核",
    "admin.nav.settings": "系统设置",
    "admin.nav.overview": "概览",
    "admin.nav.operations": "运营",
    "admin.nav.consoleLabel": "管理控制台",
    "admin.shell.searchPlaceholder": "搜索捐赠者、慈善机构、交易哈希……",
    "admin.shell.searchLabel": "搜索管理控制台",
    "admin.shell.notifications": "通知",
    "admin.shell.adminLabel": "管理员",
    "admin.shell.superAdmin": "超级管理员",
    "admin.shell.signOut": "退出登录",
    "admin.shell.backToPublicSite": "返回公开网站",
    "admin.shell.homeLink": "Give Protocol主页",
    "admin.dashboard.severityHigh": "高优先级",
    "admin.dashboard.severityMedium": "需要关注",
    "admin.dashboard.severityLow": "待审核",
    "admin.dashboard.alertOldest": "最早提交的请求",
    "admin.dashboard.alertReviewHint": "审核以保持入驻流程顺畅",
    "admin.dashboard.reviewQueue": "审核队列",
    "admin.dashboard.kpiDonorsSub": "过去30天新增{{count}}位",
    "admin.dashboard.kpiPending": "{{count}}项待处理",
    "admin.dashboard.awaitingVerification": "等待验证",
    "admin.dashboard.kpiVerifiedSub": "共{{total}}项已批准",
    "admin.dashboard.kpiVolunteersActive": "活跃报名",
    "admin.dashboard.kpiVolunteersSub": "暂无活跃报名",
    "admin.dashboard.donationVolume": "捐款总额",
    "admin.dashboard.donationVolumeSub": "{{range}} · 加密货币+法币合计",
    "admin.dashboard.range30d": "过去30天",
    "admin.dashboard.range90d": "过去90天",
    "admin.dashboard.rangeYtd": "年初至今",
    "admin.dashboard.volumeEmptyTitle": "尚无捐款记录",
    "admin.dashboard.volumeEmptySub": "首笔捐款结算后，此处将显示图表",
    "admin.dashboard.totalVolume": "总额",
    "admin.dashboard.crypto": "加密货币",
    "admin.dashboard.fiat": "法币",
    "admin.dashboard.activitySubtitle": "平台事件实时动态",
    "admin.dashboard.viewAllActivity": "查看所有活动",
    "admin.dashboard.viewAllDonations": "查看所有捐款",
    "admin.charity.tabAll": "全部",
    "admin.charity.review": "审核",
    "admin.charity.colOrganization": "机构",
    "admin.charity.colRaised": "已筹集",
    "admin.charity.colSubmitted": "提交日期",
    "admin.charity.searchAria": "搜索慈善机构",
    "admin.charity.reviewTitle": "审核{{name}}",
    "admin.charity.submittedRelative": "{{when}}提交",
    "admin.charity.contactEmail": "电子邮件",
    "admin.charity.contactPhone": "电话",
    "admin.charity.raisedUnavailable": "暂无捐款总额数据",
    "admin.error.title": "数据加载错误",
    "admin.error.recentActivity": "最近活动加载错误",
    "admin.error.alerts": "警报加载错误",
    "admin.error.donationVolume": "捐款总额加载错误",
    "donation.gas.estimating": "正在估算网络费用……",
    "donation.gas.label": "预估网络费用",
    "donation.gas.highGasWarning":
      "高额燃气费警报：预估费用为{{usd}}，占您捐款金额的{{pct}}。",
    "donation.gas.highGasSuggestion":
      "请考虑增加捐款金额或切换到费用更低的链。",
    "donation.gas.l2Hint": "如需更低费用，请尝试{{chains}}。",
  },
};
